<template>
  <div class="px-5 mx-5">
    <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: {
    seriesBuild: Array
  },
  watch: {
    seriesBuild: function(val) {
      console.log("series", val);
      if (val) {
        let newCategories = [];
        let _this = this;
        this.series = this.seriesBuild.map(data => {
          let vals = [];
          for (let i = 0; i < data.data.length; i++) {
            data.data[i].map(val => {
              let month = parseInt(val.date.split("-")[1]) - 1;
              newCategories.push(_this.toGoCategories[month]);
              vals.push(val.value);
              //return val.value;
            });
          }

          let obj = {
            name: data.name,
            data: vals
          };
          return obj;
        });
        console.log(this.series);
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            xaxis: {
              categories: newCategories
            }
          }
        };
        //this.chartOptions.xaxis.categories = [...newCategories];
      }
    }
  },
  data: function() {
    return {
      toGoCategories: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez"
      ],
      series: [],
      chartOptions: {
        chart: {
          height: 450,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [1, 1, 1],
          curve: "straight",
          dashArray: [0, 0, 0]
        },
        title: {
          text: "Gráfico atualizado",
          align: "left"
        },
        legend: {
          tooltipHoverFormatter: function(val, opts) {
            return (
              val +
              " - " +
              (opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] / 1)
                .toFixed(2)
                .replace(".", ",")
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
              ""
            );
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: []
        },
        // tooltip: {
        //   y: [
        //     //  return (val / 1)
        //     //          .toFixed(2)
        //     //          .replace(".", ",")
        //     //          .toString()
        //     //          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        //     {
        //       title: {
        //         formatter: function(val) {
        //           return val;
        //         }
        //       }
        //     },
        //     {
        //       title: {
        //         formatter: function(val) {
        //           return val;
        //         }
        //       }
        //     },
        //     {
        //       title: {
        //         formatter: function(val) {
        //           return val;
        //         }
        //       }
        //     }
        //   ]
        // },
        grid: {
          borderColor: "#f1f1f1"
        }
      }
    };
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getDataChart() {}
  }
};
</script>